
<div *ngIf="processing">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>

<div *ngIf="!processing">
  <div class="flex flex-row gap-2 justify-start items-center mb-4">
    <h1 class="portal-page-title">Online payment successful!</h1>
  </div>

  <mat-card class="portal-notice" *ngIf="isValid">
    <mat-card-content>
      <div class="flex flex-col">
        <span class="text-lg font-semibold pb-4">You have successfully submitted your payment!</span>
        <span >For payments to completely clear through the system, it can take upto 3 business days.  Most payments are processed within 24 hrs. </span>
        <span >Your payment will not immediately show as paid/cleared.  Thank you for your patience as your payment is processed.</span>
        <span >You can revisit your <strong><a [routerLink]="['/payments']" >Payments</a></strong> to view the status of your payment. </span>
        <span >If your payment has not cleared within 3 business days, then please contact the In Home Care licensing office to look into the issue. </span>
      </div>
    </mat-card-content>
  </mat-card>
</div>

